import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-labeled-input',
  standalone: true,
  imports: [FormsModule, InputTextModule, CommonModule, TranslocoPipe],
  templateUrl: './labeled-input.component.html',
  styleUrl: './labeled-input.component.css'
})
export class LabeledInputComponent implements OnChanges {
  @Input() labelText: string = '';
  @Input() iconSrc: string | null = null;
  @Input() iconAltText: string = '...';
  @Input() inputId: string = 'input';
  @Input() inputType: string = 'text';
  @Input() placeholder: string = '';
  @Input() errorMessage: string | null = null;
  @Input() warningMessage: string | null = null;
  @Input() isDisabled: boolean = false;
  @Input() boxHeight: string = '';

  @Input() inputValue: string | undefined;
  @Output() inputValueChange = new EventEmitter<string>();
  @Output() inputValueLength = new EventEmitter<number>();

  @Input() iconLeftOffset: number = 10;
  @Input() dividerOffset: number = 8;
  @Input() textInputOffset: number = 8;
  @Input() iconWidth: number = 20;
  @Input() iconHeight: number = 20;
  @Input() autocomplete: string = 'off';
  @Input() autoMarginTop: string = 'mt-4';

  @Input() title: string = '';
  @Input() disabledTitle: string | null = null;
  @Input() showOnlyValueWhenDisabled: boolean = false;

  showPassword: boolean = false;
  showTextType: string = 'text';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['inputType'] && changes['inputType'].currentValue) {
      this.showTextType = changes['inputType'].currentValue;
    }
  }

  onInputChange(event: Event) {
    const target = event.target as HTMLInputElement;

    let value = target?.value ?? '';
    // Replace comma with dot for decimal compatibility
    value = value.replace(',', '.');

    this.inputValue = value;
    this.inputValueChange.emit(this.inputValue);
    this.inputValueLength.emit(value.length);    
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
    this.showTextType = (this.showPassword) ? 'text' : 'password';
  }

  getIconStyles(): { [key: string]: string } {
    return { left: this.iconLeftOffset + 'px' };
  }

  getDividerStyles(): { [key: string]: string } {
    return { left: (this.iconLeftOffset + this.iconWidth + this.dividerOffset) + 'px' };
  }

  getInputPaddingStyles(): { [key: string]: string } {
    if (this.iconSrc) {
      return { paddingLeft: `${this.iconLeftOffset + this.dividerOffset + this.iconWidth + this.textInputOffset}px` };
    } else {
      return { paddingLeft: `${this.textInputOffset}px` };
    }
  }

  getIconSizeStyles(): { [key: string]: string } {
    return {
      width: `${this.iconWidth}px`,
      height: `${this.iconHeight}px`,
    };
  }

  get getTitle(): string {
    if (this.isDisabled && this.disabledTitle != null) {
      return this.disabledTitle;
    }

    return this.title;
  }
}
